import React from "react";
import './slider-regular.scss';
import Swipe from "../../../utils/listeners";
import GrSlideItem1Component from "../../groups/gr-slide-item-1";

export default class SliderComponent extends React.Component {

    movingSide;
    wrapperDOM;
    contentDOM;
    onResize;

    constructor() {
        super();
        this.state = {
            active: 0,
            next: 0,
            prev: 0,
            prePrev: 0,
            isSwiping: false,
            isNewState: false
        }
        this.component = React.createRef();
        this.activeMediaId = 0;
        this.firstActive = 0;
    }

    componentDidMount(){
        this.wrapperDOM = this.component.current.querySelector('.wrapperDOM');
        this.data = this.props.data;
        this.setState({
            active: 0,
            next: this.props.data.length - 1,
            prev: 1,
            prePrev: 2
        });
        if(window.innerWidth <= 768) {
            this.setActiveDOM();
            this.setNeighbors();
            this.swipeController();
        }
    }

    getMediaDOMList() {
        this.contentDOM = this.wrapperDOM.querySelectorAll('.slider-content > *');
    }

    swipeController() {
        const swiper = new Swipe(this.wrapperDOM);
        swiper.onToucheStart(() => { this.swipeStart(); });
        swiper.onDiff(() => { this.swiping(swiper); });
        swiper.onToucheEnd(() => { this.swipeEnd(swiper); });
        swiper.run();
    }

    swipeStart() {
        this.setNeighbors();
        this.swipeSpeed = 0;
        this.setState({isSwiping: true});
    }

    swiping(config) {
        if (this.props.data.length > 1) {
            this.swipeSpeed += 1;
            const shift = config.xDiff * -1;
           this.swipeTransform(shift);
        }
    }

    swipeEnd(config) {
        if (this.props.data.length > 1) {
            const shift = config.xDiff * -1;
            const colission = this.swipeSpeed < 15 ? .1 : .4;
                this.setState({
                    isSwiping: false,
                    isNewState: false
                });
            if (Math.abs(shift) > this.wrapperDOM.getBoundingClientRect().width * colission) {
                this.setState({isNewState: true});
                if (shift < 0) {
                    this.setState({ active: this.state.active === this.props.data.length - 1 ? this.state.active = 0 : this.state.active += 1});
                } else {
                this.setState({ active: this.state.active === 0 ? this.state.active = this.props.data.length - 1 : this.state.active -= 1});
                }
                this.setNeighbors();
            }
            this.contentDOM[this.state.active].style.transform = `translateX(0px)`;
            this.contentDOM[this.state.next].style.transform = `translateX(calc(100% + 20px))`;
            this.contentDOM[this.state.prev].style.transform = `translateX(calc(-100% - 20px))`;
        }
    }

    swipeTransform(shift){
        this.getMediaDOMList();
        if (this.props.data.length > 1){
            this.contentDOM[this.state.active].style.transform = `translateX(${shift}px)`;
            if (shift < 0 ) {
                this.contentDOM[this.state.next].style.transform = `translateX(calc(100% + 20px + ${shift}px))`;
                this.movingSide = 1;
            } else {
                this.contentDOM[this.state.prev].style.transform = `translateX(calc(-100% - 20px + ${shift}px))`;
                this.contentDOM[this.state.next].style.transform = `translateX(calc(100% + 20px + ${shift}px))`;
                this.movingSide = -1;
            }
        }
    }

    setNeighbors() {
        this.setState({ 
            next: this.state.active === this.props.data.length - 1 ? 0 : this.state.active + 1,
            prev: this.state.active === 0 ? this.props.data.length - 1 : this.state.active - 1,
        });
    }

    previous() {
        this.setState({ 
            active: (this.state.active > 0 ? this.state.active : this.props.data.length) - 1,
            next: (this.state.next > 0 ? this.state.next : this.props.data.length) - 1,
            prev: (this.state.prev > 0 ? this.state.prev : this.props.data.length) - 1,
            prePrev: (this.state.prePrev > 0 ? this.state.prePrev : this.props.data.length) - 1
        });
    }

    next() {
        this.setState({ 
            active: (this.state.active < this.props.data.length - 1 ? this.state.active : -1) + 1,
            next: (this.state.next < this.props.data.length - 1 ? this.state.next : -1) + 1,
            prev: (this.state.prev < this.props.data.length - 1 ? this.state.prev : -1) + 1,
            prePrev: (this.state.prePrev < this.props.data.length - 1 ? this.state.prePrev : -1) + 1
        });
    }

    setActiveDOM() {
        this.activeDOM = this.wrapperDOM.querySelectorAll('.filler')[this.activeMediaId];
    }

    render(){
        return (
            <div className="slider-regular" ref={this.component}>
                <div className={`arrow arrow-left ${this.props.data.length <= 1 ? 'disabled' : ''}`} onClick={() => this.previous()}>
                    <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542616/hp2021/general/arrow.svg" alt="#" />
                </div>

                <ul className="pagination">
                    {this.props.data.map((val, index) =>
                        <li key={index} className={`${this.state.active === index ? 'active' : ''}`}></li>
                    )}
                </ul>
                <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542616/hp2021/general/quote.svg" alt="#" className="quote quote-1"/>
                <div className={`wrapperDOM slider-content ${this.state.isSwiping ? 'swiping' : ''} ${this.movingSide > 0 ? 'to-left' : ''} ${this.movingSide < 0 ? 'to-right' : ''} ${this.state.isNewState ? 'new-state' : ''}`}>
                    {this.props.data.map((value, i) =>
                        <div key={i} data-index={i} className={`filler ${this.state.active === i ? 'current' : this.state.next === i ? 'next' : this.state.prev === i ? 'previous' : this.state.prePrev === i ? 'pre-previous' : ''}`}>
                            <GrSlideItem1Component data={value}></GrSlideItem1Component>
                        </div>
                    )}
                </div>
                <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542616/hp2021/general/quote.svg" alt="#" className="quote quote-2"/>

                <div className={`arrow arrow-right ${this.props.data.length <= 1 ? 'disabled' : ''}`}  onClick={() => this.next()}>
                    <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542616/hp2021/general/arrow.svg" alt="#" />
                </div>
            </div>
        );
    }
}